export enum PledgeType {
  LiHeap = 'LIHEAP',
  Crisis = 'Crisis',
  Other = 'Other',
}
